import { render, staticRenderFns } from "./mockExam.vue?vue&type=template&id=4884c202&scoped=true&"
import script from "./mockExam.vue?vue&type=script&lang=js&"
export * from "./mockExam.vue?vue&type=script&lang=js&"
import style0 from "./mockExam.vue?vue&type=style&index=0&id=4884c202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884c202",
  null
  
)

export default component.exports